import React from 'react';

// Logo principal GEO Frequência — SVG inline (evita bloqueio do service worker em /logo.png)
export const GeoLogo = ({ size = 40, light = false }: { size?: number; light?: boolean }) => {
  const navy  = light ? '#ffffff' : '#0a1128';
  const royal = light ? '#90b8ff' : '#1e40ff';
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* haste do cronômetro */}
      <rect x="52" y="4" width="16" height="8" rx="2" fill={navy}/>
      <rect x="50" y="10" width="20" height="5" rx="1.5" fill={navy}/>
      {/* botões laterais */}
      <rect x="22" y="22" width="9" height="4" rx="1.5" fill={navy} transform="rotate(-40 22 22)"/>
      <rect x="89" y="22" width="9" height="4" rx="1.5" fill={navy} transform="rotate(40 93 25)"/>
      {/* círculo externo */}
      <circle cx="60" cy="70" r="46" stroke={navy} strokeWidth="5" fill={light ? 'rgba(255,255,255,0.08)' : 'white'}/>
      {/* marcações do relógio */}
      {[...Array(12)].map((_, i) => {
        const a = (i * 30 - 90) * Math.PI / 180;
        const r1 = 42, r2 = i % 3 === 0 ? 34 : 37;
        return <line key={i} x1={60+r1*Math.cos(a)} y1={70+r1*Math.sin(a)} x2={60+r2*Math.cos(a)} y2={70+r2*Math.sin(a)} stroke={navy} strokeWidth={i%3===0?3:1.5} strokeLinecap="round"/>;
      })}
      {/* arco royal-blue (o G + seta da logo) */}
      <path d="M 78 50 A 22 22 0 1 0 78 90 L 65 90 L 65 78 L 78 78" stroke={royal} strokeWidth="6" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      <polygon points="78,50 86,44 84,56" fill={royal}/>
      {/* pontos estilo QR */}
      {([[54,62],[59,62],[64,62],[54,67],[64,67],[54,72],[59,72],[64,72]] as [number,number][]).map(([x,y],i) => (
        <rect key={i} x={x} y={y} width="3" height="3" rx="0.5" fill={navy}/>
      ))}
    </svg>
  );
};

export const GeoLogoIcon = ({ size = 20, color = "white" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill={color}/>
  </svg>
);

export const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
    <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"/>
    <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
  </svg>
);
